import { render, staticRenderFns } from "./BitProp.vue?vue&type=template&id=73aa73bd"
import script from "./BitProp.vue?vue&type=script&lang=js"
export * from "./BitProp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports